import React from 'react'
import HelpIcon from '../../assets/icons/help.svg'
import { HelpButton } from '../../styles/help'
import { Icon } from '../../styles/image'
import { LabelExtra } from '../../styles/elements'

export default ({ text, onClick }) => {
    return (
        <HelpButton onClick={onClick}>
            <LabelExtra isLink padding="0px 4px">{text}</LabelExtra>
            <Icon isLink src={HelpIcon} alt={text} width="24px" isSquare />
        </HelpButton>
    )
}